// extracted by css-extract-rspack-plugin
export default {"header":"cGS4Tv1r9QgUG6kP","count":"hTRmFWPZAmcRiPRN"};